import React, { useEffect } from 'react';
import Report from '@/pages/intelligence/pages/InsightsReport/report';
import { useIntl } from 'umi';
import { getReportBySystemTypeApi } from '@intelligence/services/reportService';
import { dbiPageLogMes } from "@/pages/intelligence/utils/buriedPointCfg";
import { buriedPointPage, } from "@/pages/home/utils/buriedPoint";
import { pageReportTypeConfig } from '@intelligence/pages/InsightsReport/_config';

const GameAnalysis = () => {
  const { formatMessage } = useIntl();

  useEffect(() => {
    buriedPointPage(dbiPageLogMes.gameAnalysisReport);
  }, []);

  return (
    <Report
      reportType="gameAnalysis"
      title={formatMessage({ id: 'dbi_game_analysis_report_title' })}
      subTitle={formatMessage({ id: 'dbi_game_analysis_report_sub_title' })}
      getReportFun={() => getReportBySystemTypeApi('game_analysis')}
      searchType={'GameAnalysisSearch'}
      pageLogMes={dbiPageLogMes.gameAnalysisReport}
      reportTypeConfig={pageReportTypeConfig.gameAnalysis}
    />
  );
};

export default GameAnalysis;
